const General = () => import(/* webpackChunkName: "general setting" */ '@/components/settings/general')
export default {
    name: 'general',
    path: 'settings/general',
    redirect: '/settings/general/index',
    meta: {label: 'general'},
    component: {
        render (c) { return c('router-view') }
    },
    children: [
        {
            path: 'index',
            meta: {label: 'Index', auth: [0, 1, 2, 3, 4, 5, 6, 7, 10]},
            component: General,
            props: true
        }
    ]
}
